import { TableChartConfigDto, BallStrikeSummaryChartDto } from 'types/CodegenReportTypes';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type BatterBallStrikeSummaryChartColumn = keyof BallStrikeSummaryChartDto['ballStrikeSummaries'][number];

const BatterBallStrikeSummaryChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<BallStrikeSummaryChartDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<BatterBallStrikeSummaryChartColumn | '' | 'id'>('count');

  const rows = useMemo(
    () =>
      chartData?.ballStrikeSummaries.map((row, i) => ({
        ...row,
        id: i.toString(),
      })) ?? [],
    [chartData?.ballStrikeSummaries]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<BatterBallStrikeSummaryChartColumn>(chartConfig.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [chartConfig.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
      skeletonRows={12}
    />
  );
};

export default BatterBallStrikeSummaryChart;
